import {Col, Row } from 'antd';
import React from 'react';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import CustomEmpty from '../../../../../../../components/custom-empty';
import FormList from '../../../../../../../components/form-list';
import { GUTTER_MD, SPAN_ONE_QUARTER, SPAN_THREE_QUARTERS } from '../../../../../../../styles/constants';
import { getComponentsFromCubeComponents } from '../../../utils';
import ConcatenatedValue from './ConcatenatedValue';

const ConcatenatedComponent = ({
    t,
    componentValueDefinition,
    cubeComponents,
    onComponentValueDefinitionValueSet,
  }) => {    

    const components = getComponentsFromCubeComponents(cubeComponents, [componentValueDefinition.cubeComponent.name], true);
    const valuesNumber = (componentValueDefinition.mappingValue.concatenatedValues || []).length;

    return (
      valuesNumber > 0
      ? <Row gutter={GUTTER_MD} type="flex" align="top">
          <Col span={SPAN_ONE_QUARTER}>
            {`${componentValueDefinition.cubeComponent.name}=`}
          </Col>
          <Col span={SPAN_THREE_QUARTERS}>
            <FormList
                compact
                notCollapsable
                values={componentValueDefinition.mappingValue.concatenatedValues}
                Component={ConcatenatedValue}
                componentProps={
                    {components:components}
                }
                newItem={{
                  name: components[0].name,
                  text: ""        
                  }
                }
                minItems={1}
                addItemLabel={t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.addColumn.title')}
                removeItemLabel={t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.removeColumn.title')}
                onChange={values => onComponentValueDefinitionValueSet(values)}
            /> 
          </Col>
        </Row>      
      : <CustomEmpty/>
    );   
  };

export default compose(
  translate(),
)(ConcatenatedComponent);
